import angular from 'angular';
import template from './dashboardGraphsView.html';

export class DashboardGraphsComponent {
    /* @ngInject */
    constructor($stateParams, $state) {
        const dashboardGraphsCtrl = this;
        dashboardGraphsCtrl.init = function () {
            if (!$stateParams.type) {
                dashboardGraphsCtrl.selected = 'dashboard';
            } else {
                dashboardGraphsCtrl.selected = $stateParams.type;
            }
        };

        dashboardGraphsCtrl.goToDefault = function () {
            $state.go('talenya.dashboard', { type: 'dashboard' });
        };

        dashboardGraphsCtrl.init();
    }
}

export const DashboardGraphsComponentConfiguration = {
    template,
    controller: DashboardGraphsComponent,
    controllerAs: 'dashboardGraphsCtrl',
};

angular
    .module('TALENYA-FE')
    .component('dashboardGraphsComponent', DashboardGraphsComponentConfiguration);
